import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import { api } from './api';
import { Server } from './types';

export default function TerminalList() {
    const [servers, setServers] = useState<Server[]>([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        api.get<Server[]>('/servers')
            .then(setServers)
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
                <header className="page-header">
                    <h1>Терминал — выберите сервер</h1>
                </header>

                {loading ? (
                    <div className="loading-screen">Загрузка...</div>
                ) : servers.length === 0 ? (
                    <div className="empty-state">
                        <div className="empty-icon">💻</div>
                        <h2>Серверов нет</h2>
                        <p>Сначала добавьте сервер</p>
                        <button className="btn-primary" style={{ maxWidth: 200 }}
                                onClick={() => navigate('/servers')}>
                            Перейти к серверам
                        </button>
                    </div>
                ) : (
                    <div className="server-cards">
                        {servers.map(s => (
                            <div
                                key={s.id}
                                className={`server-card-mini ${s.status}`}
                                onClick={() => navigate(`/terminal/${s.id}`)}
                            >
                                <div className="scm-status-dot" />
                                <div style={{ flex: 1 }}>
                                    <div className="scm-name">{s.name}</div>
                                    <div className="scm-host">{s.host}</div>
                                </div>
                                <span style={{ fontSize: 20 }}>💻</span>
                            </div>
                        ))}
                    </div>
                )}
            </main>
        </div>
    );
}

